import React, { Fragment, useState } from "react";
import { Lock, Mail, User, Phone, Code, Key } from "react-feather";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Form, FormGroup, Input, InputGroup, Label } from "reactstrap";
import { Btn, H4, H5, H6, LI, P, UL } from "../../../AbstractElements";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import Language from "../../../Layout/Header/Langauge";
import {
  CreateAccount,
  EmailAddress,
  Password,
  PhoneNumber,
  PrivacyPolicy,
  SignIn,
  YourName,
  Continue,
  BackgroundColor,
  OTPTEXT,
} from "../../../Constant";
import {
  FaceBookSVG,
  GoogleSVG,
  InstagramSVG,
  TwitterSVG,
} from "../../../Data/svgIcons";
import imgg from "../../../assets/images/logo/logo.png";

const RegisterFrom = () => {
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState();
  const lang = localStorage?.getItem('i18nextLng');
  const [togglePassword, setTogglePassword] = useState(false);
  const [togglePassword2, setTogglePassword2] = useState(false);
  const [otpCode, setOtpCode] = useState();
  const { t } = useTranslation();
  const [password, setPassword] = useState();
  const navigate = useNavigate();

  const handleNext = (event) => {
    event.preventDefault();
    if (step === 1 && phoneNumber !== "" && phoneNumber?.length === 10) {
      setStep(2);
    } else {
      toast.error("Please enter valid phone number");
    }
  };

  const handleOtp = (event) => {
    event.preventDefault();
    if (otpCode !== "" && otpCode?.length === 4) {
      setStep(3);
    } else {
      toast.error("Please enter valid OTP");
    }
  };

  const handleRegister = async (event) => {
    event.preventDefault();
    if (password?.trim() !== "") {
      try {
        const response = await axios.post(
          `https://api-portal.nada.org.np/api/users`,
          {
            phone_number: phoneNumber,
            otp: otpCode,
            password: password,
          }
        );

        if (response?.data?.success) {
          toast.success("User registered successfully!");
          localStorage.setItem("token", response?.data?.data?.token);
          localStorage.setItem(
            "currentUser",
            response?.data?.data?.phone_number
          );
          localStorage.setItem("authenticated", "true");
          window.location.href = `${process.env.PUBLIC_URL}/dashboard`;
        }
      } catch (error) {
        if (error.response) {
        } else if (error.request) {
          console.error("Error request:", error.request);
        } else {
          console.error("Error message:", error.message);
        }
      }
    } else {
      toast.error("Please enter valid password");
    }
  };

  return (
    <Fragment>
      <Form
        className="theme-form login-form"
        style={{ position: 'relative' }}
        onSubmit={
          step === 1 ? handleNext : step === 2 ? handleOtp : handleRegister
        }
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 20,
            paddingBottom: "20px",
          }}
        >
          <img src={imgg} alt="Logo" style={{ width: "100px" }} />
          <div
            className="login-header text-center"
            style={{ paddingTop: "40px", justifySelf: "flex-end" }}
          >
            <H4>{t("Create your account")}</H4>
            <H6>{t("Enter your phone number to start")}</H6>
          </div>
        </div>
        <FormGroup>
          <Label>{t("Phone Number")}</Label>
          <InputGroup>
            <span className="input-group-text">
              <Phone />
            </span>
            <Input
              maxLength={10}
              size={10}
              onChange={(e) => setPhoneNumber(e.target.value)}
              value={phoneNumber}
              className="form-control"
              type="number"
              required=""
              placeholder="Please Enter Your Phone Number"
            />
          </InputGroup>
        </FormGroup>
        {(step === 2 || step === 3) && (
          <FormGroup>
            <Label>{t("OTP Code")}</Label>
            <InputGroup>
              <span className="input-group-text">
                <Key />
              </span>
              <Input
                className="form-control"
                type={togglePassword ? "text" : "password"}
                //name="login[password]"
                required=""
                maxLength={4}
                onChange={(e) => setOtpCode(e.target.value)}
                value={otpCode}
                placeholder={t("Enter 4-digit code")}
              />
              <div
              className="show-hide"
              onClick={() => setTogglePassword(!togglePassword)}
            >
              <span className={togglePassword ? "" : "show"}></span>
            </div>
            </InputGroup>
          </FormGroup>
        )}
        {step === 3 && (
          <FormGroup>
            <Label>{t("Password")}</Label>
            <InputGroup>
              <span className="input-group-text">
                <Lock />
              </span>
              <Input
                className="form-control"
                type={togglePassword2 ? "text" : "password"}
                name="login[password]"
                required=""
                placeholder="*********"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />
              <div
              className="show-hide"
              onClick={() => setTogglePassword2(!togglePassword2)}
            >
              <span className={togglePassword2 ? "" : "show"}></span>
            </div>
            </InputGroup>
          </FormGroup>
        )}
        <FormGroup>
          <Btn
            style={{ backgroundColor: "#16323C" }}
            attrBtn={{
              className: "btn-block",
              color: "primary",
              type: "submit",
            }}
          >
            {t("Continue")}
          </Btn>
        </FormGroup>
        <P>
          {t("Already have an account?")}
          <Link to={`${process.env.PUBLIC_URL}/login`} className="ms-2">
            {t("Sign In")}
          </Link>
        </P>
        <div style={{ position: 'absolute', top: 1, right: -60, backgroundColor: '#fff', width: 50, height: 40, alignItems: 'center', display: 'flex', justifyContent:'center', borderRadius: '8px' }}>
        <UL attrUL={{ className: `simple-list flex-row nav-menus` }}>
        <LI attrLI={{ className: 'onhover-dropdown' }}><H6 attrH6={{ className: 'txt-dark mb-0 mt-1' }}>{lang === 'es'? 'NP' : 'EN'}</H6>
            <Language />
          </LI>
          </UL>
        </div>
      </Form>
    </Fragment>
  );
};

export default RegisterFrom;
